<div class="d-flex h-100 text-center">
    <div class="cover-container d-flex w-100 h-100 p-3 mx-auto flex-column">
        <app-navigation/>

        <div class="features-container">
            <h1 class="display-4 text-center my-4">Unsere Funktionen</h1>
            <p class="lead text-center mb-5">Entdecken Sie, wie <span class="highlight">ManualRadar</span> Ihre Dokumentenverwaltung revolutioniert</p>

            <div class="feature-cards">
                <div class="feature-card">
                    <div class="feature-icon">
                        <i class="fas fa-qrcode text-warning"></i>
                    </div>
                    <h3>Dokumente per QR-Code abrufen</h3>
                    <p>Speichern Sie Dokumente und ganze Ordnerstrukturen sicher und rufen Sie diese jederzeit per QR-Code ab. Ideal für Hausverwaltungen, Unternehmen oder technische Dokumentationen.</p>
                </div>

                <div class="feature-card">
                    <div class="feature-icon">
                        <i class="fas fa-share-alt text-warning"></i>
                    </div>
                    <h3>Gezielte Freigabe</h3>
                    <p>Teilen Sie nicht nur einzelne Dokumente, sondern komplette Ordner mit mehreren Dateien. Definieren Sie Zugriffsrechte und erhöhen Sie die Sicherheit durch optionale Passwörter.</p>
                </div>

                <div class="feature-card">
                    <div class="feature-icon">
                        <i class="fas fa-folder text-warning"></i>
                    </div>
                    <h3>Strukturierte Organisation</h3>
                    <p>Organisieren Sie Ihre Dateien in einer klaren Hierarchie mit individuellen Metadaten und optionalem Ablaufdatum für stets aktuelle und übersichtliche Unterlagen. Bei Bedarf können Sie auch Hyperlinks zu externen Quellen anlegen, um relevante Informationen zu verknüpfen.</p>
                </div>
            </div>

            <div class="use-cases mt-5">
                <h2 class="text-center mb-4">Anwendungsbereiche</h2>

                <div class="use-case-item">
                    <div class="use-case-icon">
                        <i class="fas fa-building text-warning"></i>
                    </div>
                    <div class="use-case-content">
                        <h4>Hausverwaltungen</h4>
                        <p>Hinterlegen Sie Mietverträge, Wartungsprotokolle oder Hausordnungen digital – Mieter können per QR-Code jederzeit darauf zugreifen.</p>
                    </div>
                </div>

                <div class="use-case-item">
                    <div class="use-case-icon">
                        <i class="fas fa-industry text-warning"></i>
                    </div>
                    <div class="use-case-content">
                        <h4>Industrie & Maschinenbau</h4>
                        <p>Verknüpfen Sie QR-Codes mit Maschinen, um Bedienungsanleitungen, Wartungshinweise und Sicherheitsdokumente sofort bereitzustellen.</p>
                    </div>
                </div>

                <div class="use-case-item">
                    <div class="use-case-icon">
                        <i class="fas fa-users text-warning"></i>
                    </div>
                    <div class="use-case-content">
                        <h4>Büro & Teams</h4>
                        <p>Teilen Sie wichtige Dokumente innerhalb Ihres Unternehmens ohne komplizierte Zugriffsrechte oder umständlichen E-Mail-Verkehr.</p>
                    </div>
                </div>
            </div>

            <div class="cta-section text-center mt-5">
                <h3>Bereit zum Starten?</h3>
                <p class="lead">Jeder Ordner und jedes Dokument erhält einen eigenen QR-Code. Einfach scannen, direkt abrufen – egal wann und wo.</p>
                <div class="d-flex justify-content-center gap-3">
                    <a class="btn btn-warning btn-lg mt-3" [routerLink]="['/demo']">
                        <i class="fas fa-play-circle me-2"></i>Demo ausprobieren
                    </a>
                    <a class="btn btn-warning btn-lg mt-3" href="mailto:info@noteradar.at">
                        <i class="fas fa-paper-plane me-2"></i>Kontakt aufnehmen
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>
